import { render, staticRenderFns } from "./logout.vue?vue&type=template&id=482961b4&scoped=true"
import script from "./logout.vue?vue&type=script&lang=js"
export * from "./logout.vue?vue&type=script&lang=js"
import style1 from "./logout.vue?vue&type=style&index=1&id=482961b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482961b4",
  null
  
)

export default component.exports